class gTagEvents {
  constructor() {
      this.delegateBody = new Delegate(document.body);      

      this.bindEvents();
      this.observeDOMChanges();
      this.handleIntersects();

      this.interceptCartApi();
  }

  bindEvents() {
    this.delegateBody.on("add:to:cart", this.cartAdd.bind(this));
    this.delegateBody.on("click", "button[name='checkout']", this.handleCheckout.bind(this));
    this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
    this.delegateBody.on('variant:changed:gtm', this.handleVariantChange.bind(this));
  }

  observeDOMChanges() {
      const observer = new MutationObserver((mutationsList, observer) => {
          // For each mutation record, we look for added nodes
          for (const mutation of mutationsList) {
              if (mutation.addedNodes.length) {
                  // If there are added nodes, we call handleIntersects to check for new items
                  this.handleIntersects();
              }
          }
      });

      // Start observing the document body for added nodes and subtree modifications
      observer.observe(document.body, {
          childList: true, // Observe direct children
          subtree: true, // and all descendants
          attributes: false // Set to true if you also want to observe attribute changes
      });
  }

  handleIntersects() {
      const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

      allIntersections.forEach((item) => {
          const observer = new IntersectionObserver(
              this.handleIntersection.bind(this),
              {
                  root: null, // Use the viewport as the root
                  rootMargin: "0px",
                  threshold: 0.1, // Adjust the threshold as per your requirement
              }
          );

          observer.observe(item);
          item.dataset.observed = "true";
      });
  }

  handleIntersection(entries) {
      entries.forEach((entry) => {
          if (entry.isIntersecting) {
              let data = false;

              try {
                  data = JSON.parse(
                      entry.target.querySelector('script[type="application/ld+json"]').textContent
                  );

              } catch (e) {
                  console.log("JSON parse failed", e);
              }

              if (!dataLayer || !data) return;

              dataLayer.push({ ecommerce: null });
              dataLayer.push(data);
              console.log("dataLayer push -> custom_view_item_list:", data);

              //console.log(data, "And pushed to dataLayer");
          }
      });
  }

  handleVariantChange(event) {        
    // get current variant id from url
	const params = new URLSearchParams(window.location.search);
	const variantIdParam = params.get("variant");

	if (!variantIdParam) return;
	const currentVariantID = Number(variantIdParam);

    // find current variant json in ShopifyAnalytics
    const variants = ShopifyAnalytics.meta.product.variants;
    let currentVariant = null;

    variants.forEach(variant => {        
        if (variant.id === currentVariantID) currentVariant = variant;
    })

    // get and update gtm script
    const dataElem = document.querySelector('.main-product__gtm-script');    
    if (!currentVariant || !dataElem) return;
    
    const data = JSON.parse(dataElem.textContent);
    const item = data.ecommerce.items[0];
    
    item.item_variant = currentVariant.public_title || "Default Title";
    item.item_id = currentVariant.id || "";
    item.item_sku = currentVariant.sku || "";
    item.price = currentVariant.price / 100;
    item.quantity = 1;

    data.ecommerce.value = currentVariant.price / 100;

    if (!dataLayer || !data) return;

    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
    console.log(data, "And pushed to dataLayer");
}

  interceptCartApi() {
      const originalFetch = window.fetch;
      const _this = this;

      window.fetch = async function (...args) {
          try {            
              const [url, request] = [...args];              
              
              // Trigger custom logic for cart clear API
              if (url.includes(`/cart/clear.js`)) _this.cartClear();
              if (url.includes(`/cart/update.js`)) _this.cartUpdate(request.body);

              const response = await originalFetch.apply(this, args);
              if (!response.ok) return response;

              // Early return for non-cart-related APIs or missing conditions
              if (url === '' || !dataLayer || !url.includes(`/cart/change.js`)) return response;             

              // Clone response to safely process its JSON
              const responseClone = response.clone();
              const json = await responseClone.json();  

              _this.cartChange(json);

              return response;

          } catch (e) {
              console.error('Fetch interceptor error:', e);
              return originalFetch(...args);
          }
      };
  }

  async cartAdd() {
  const product = event.detail.product;
  if (!product) return;

  const form = event.detail.form;
  if (!form) {
    return this.productAdded([product]);
  }

  const params = new URLSearchParams(form);
  
  // Assign all properties in one go with a mapping object
  const paramMappings = {
    'quantity': { key: 'quantity', transform: Number },
    '_gtm-category': { key: 'category' },
    '_gtm-category2': { key: 'category_2' },
    '_gtm-item_brand': { key: 'brand' },
    '_gtm-list_id': { key: 'list_id' },
    '_gtm-list_name': { key: 'list_name' } 
  };

  // Process all parameters efficiently
  Object.entries(paramMappings).forEach(([paramName, { key, transform }]) => {
    const value = params.get(paramName);
    if (value) {
      product[key] = transform ? transform(value) : value;
    }
  });

  this.productAdded([product]);
}

  async cartUpdate(body) {
    if (!body) return;
    const updates = JSON.parse(body).updates;

    const oldCart = await this.getCart();
    const cartItems = oldCart.items, itemsAdded = [], itemsRemoved = [];

    cartItems.forEach(item => {            
        const newQuantity = updates[item.key];
        if (typeof newQuantity === "number") {
            const change = newQuantity - item.quantity;
            item.quantity = Math.abs(change);

            change < 1 ? itemsRemoved.push(item) : itemsAdded.push(item);
        }
    })

    this.productAdded(itemsAdded);
    this.productsRemoved(itemsRemoved);
}

  async cartChange(cart) {
      this.productAdded(cart.items_added);
      this.productsRemoved(cart.items_removed);
  }

  async cartClear() {
      const cart = await this.getCart();
      this.productsRemoved(cart.items);
  }

    async getCart() {
      try {
          const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
              method: "GET",
              headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
              },
          });

          return await response.json();

      } catch (error) {
          console.log('Fetch Error:', error);
      }
    }

    productAdded(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const customEvent = {
            'event': 'custom_add_to_cart',
            'ecommerce': this.buildEcommerce(cartItems)
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_add_to_cart:", customEvent);
    }

    productsRemoved(cartItems) {
      if (!cartItems || !cartItems.length) return;

      const customEvent = {
            'event': "custom_remove_from_cart",
            'ecommerce': this.buildEcommerce(cartItems)
      }

      dataLayer.push({ ecommerce: null });
      dataLayer.push(customEvent);
      console.log("dataLayer push -> custom_remove_from_cart:", customEvent);
    }

    handleCheckout() {
      const button = event.target.closest("button[name='checkout']");
      if (!button) return;

      const script = button.parentElement.querySelector('[type="application/ld+json"]');
      const settings = JSON.parse(script.innerText);

      if (!dataLayer || !settings) return;

      dataLayer.push({ ecommerce: null });
      dataLayer.push(settings);

      console.log("checkoutFired", settings);
      console.log("dataLayer push -> checkoutFired:", settings);
    }

    handleSelectItem(event) {    
      let target = event.target.closest('[data-action="ga-send-select"]');
      if (!target || !dataLayer) return;

      const settings = JSON.parse(target.dataset.selectSettings);
      if (!settings) return;

      const customEvent = {
        event: "custom_select_item",
        ecommerce: {
            item_list_id: settings.list_id,
            item_list_name: settings.list_name,
            currency: ShopifyAnalytics.meta.currency,
            items: [settings]
        }
      }

      dataLayer.push({ ecommerce: null });
      dataLayer.push(customEvent);
      console.log("dataLayer push -> custom_select_item:", customEvent);
    }

    buildEcommerce(cartItems) {
        const items = [];
        let totalPrice = 0;        

        cartItems.forEach((item) => {            
            const price = typeof item.price === "number" ? item.price / 100 : Number(item.price);
            totalPrice += price * item.quantity;
            
            const product = {
                'item_id': item.sku || "",
                'item_name': item.untranslated_product_title || item.title || "",
                'item_variant': item.untranslated_variant_title || "Default Title",
                'price': price, 
                'quantity': item.quantity,
                'category': item.category || "",
                'category2': item.category_2 || "",
                'item_brand': item.item_brand || "",
                'list_id': item.list_id || "",
                'list_name': item.list_name || ""
            }

            items.push(product);
        });

        return {
            'value': totalPrice,
            'currency': ShopifyAnalytics.meta.currency,
            'items': items
        }
    }
}

new gTagEvents();